import React from 'react';
import Icon from '../../../components/AppIcon';

const OrderSummarySection = ({ items, subtotal, deliveryFee, total }) => {
  return (
    <div className="bg-card rounded-xl shadow-lg p-4 md:p-6 lg:p-8">
      <div className="flex items-center gap-3 mb-4 md:mb-6">
        <div className="w-10 h-10 md:w-12 md:h-12 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="ShoppingBag" size={20} color="var(--color-primary)" />
        </div>
        <h2 className="text-lg md:text-xl lg:text-2xl font-bold text-foreground">Order Summary</h2>
      </div>

      <div className="space-y-3 md:space-y-4 mb-4 md:mb-6">
        {items?.map((item) => (
          <div key={item?.id} className="flex gap-3 md:gap-4 p-3 md:p-4 bg-muted/50 rounded-lg">
            <div className="flex-1 min-w-0">
              <div className="flex items-start justify-between gap-2 mb-1">
                <h3 className="font-semibold text-foreground text-sm md:text-base line-clamp-1">
                  {item?.name}
                </h3>
                <span className="text-sm md:text-base font-semibold text-foreground whitespace-nowrap">
                  SSP {(item?.price * item?.quantity)?.toLocaleString()}
                </span>
              </div>
              <p className="text-xs md:text-sm text-muted-foreground">
                Quantity: {item?.quantity} × SSP {item?.price?.toLocaleString()}
              </p>
              {item?.customization && (
                <p className="text-xs text-muted-foreground mt-1 italic">
                  Note: {item?.customization}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="border-t border-border pt-4 md:pt-6 space-y-2 md:space-y-3">
        <div className="flex justify-between text-sm md:text-base">
          <span className="text-muted-foreground">Subtotal</span>
          <span className="font-semibold text-foreground">SSP {subtotal?.toLocaleString()}</span>
        </div>
        <div className="flex justify-between text-sm md:text-base">
          <span className="text-muted-foreground">Delivery Fee</span>
          <span className="font-semibold text-foreground">
            {deliveryFee === 0 ? (
              <span className="text-accent">FREE</span>
            ) : (
              `SSP ${deliveryFee?.toLocaleString()}`
            )}
          </span>
        </div>
        <div className="flex justify-between text-base md:text-lg lg:text-xl pt-2 md:pt-3 border-t border-border">
          <span className="font-bold text-foreground">Total</span>
          <span className="font-bold text-primary">SSP {total?.toLocaleString()}</span>
        </div>
      </div>
    </div>
  );
};

export default OrderSummarySection;